"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    TeachingPopoverCarouselNavButton: function() {
        return _TeachingPopoverCarouselNavButton.TeachingPopoverCarouselNavButton;
    },
    renderTeachingPopoverCarouselNavButton_unstable: function() {
        return _renderTeachingPopoverCarouselNavButton.renderTeachingPopoverCarouselNavButton_unstable;
    },
    teachingPopoverCarouselNavButtonClassNames: function() {
        return _useTeachingPopoverCarouselNavButtonStylesstyles.teachingPopoverCarouselNavButtonClassNames;
    },
    useTeachingPopoverCarouselNavButtonStyles_unstable: function() {
        return _useTeachingPopoverCarouselNavButtonStylesstyles.useTeachingPopoverCarouselNavButtonStyles_unstable;
    },
    useTeachingPopoverCarouselNavButton_unstable: function() {
        return _useTeachingPopoverCarouselNavButton.useTeachingPopoverCarouselNavButton_unstable;
    }
});
const _TeachingPopoverCarouselNavButton = require("./TeachingPopoverCarouselNavButton");
const _renderTeachingPopoverCarouselNavButton = require("./renderTeachingPopoverCarouselNavButton");
const _useTeachingPopoverCarouselNavButton = require("./useTeachingPopoverCarouselNavButton");
const _useTeachingPopoverCarouselNavButtonStylesstyles = require("./useTeachingPopoverCarouselNavButtonStyles.styles");
